export const header = (isTouchDevice) => {

  const header = document.querySelector('.js-header');
  const main = document.querySelector('.js-main');

  // let offset = main.offsetTop + header.offsetHeight;
  let offset = main.offsetTop;
  let scrolledPastOffset = false;

  window.addEventListener('resize', function() {
    // offset = main.offsetTop + header.offsetHeight;
    offset = main.offsetTop;
  });

  //Header behaviour on touch devices.
  //Show header when scrolling back up. Hide header when scrolling down.
  // alert('isTouchDevice = ' + isTouchDevice);
  
  if(isTouchDevice) {

    let headroom = new Headroom(header, {
      tolerance: 5,
      offset: offset,
      classes: {
        onPin: "c-site-header--is-full",
        onUnpin: "c-site-header--is-minimised"
      },
      onPin : function() {
        document.body.classList.remove("header--is-minimised");
      },
      onUnpin : function() {
        document.body.classList.add("header--is-minimised");  
      },
      onTop : function() {
        document.body.classList.remove("header--is-minimised");
      },
      onNotTop : function() {
        document.body.classList.add("header--is-minimised");  
      },
    });
  
    headroom.init();

  } else {

    let headroom = new Headroom(header, {
      tolerance: 5,
      offset: offset,
      classes: {
        top : "c-site-header--is-full",
        notTop : "c-site-header--is-minimised",
      },
      onTop : function() {
        scrolledPastOffset = false;
        document.body.classList.remove("header--is-minimised");
      },
      onNotTop : function() {
        scrolledPastOffset = true;
        document.body.classList.add("header--is-minimised");  
      },
    });

    headroom.init();

  }

 
  
  //Header behaviour on desktop/ non-touch devices
  //Only show header on mouseover
  if(!isTouchDevice) {

    header.addEventListener("mouseover", mOver, false);
    header.addEventListener("mouseout", mOut, false);

    function mOver() {
      document.body.classList.remove("header--is-minimised");
    }

    function mOut() {  
      if(scrolledPastOffset == true) {
        document.body.classList.add("header--is-minimised");
      }
    }

  }


  //Header behaviour for both mobile and desktop: Always show and only start hiding when scrolled past the introduction block

  function debounce(func, wait = 10, immediate = true) {
    let timeout;
    return function() {
      let context = this, args = arguments;
      let later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      let callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  // function checkPosition() {
  //   if(window.scrollY > offset) {
  //     header.classList.add('c-site-header--is-minimised');
  //   } else {
  //     header.classList.remove('c-site-header--is-minimised');
  //   }
  // }

  // window.addEventListener('scroll', debounce(checkPosition));

  const observer = new IntersectionObserver(
    ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
    {threshold: [1]}
  );

  observer.observe(header);

}
